import { render, staticRenderFns } from "./vitransfer.vue?vue&type=template&id=19c63d5d&scoped=true&"
import script from "./vitransfer.vue?vue&type=script&lang=js&"
export * from "./vitransfer.vue?vue&type=script&lang=js&"
import style0 from "./vitransfer.vue?vue&type=style&index=0&lang=css&"
import style1 from "./vitransfer.vue?vue&type=style&index=1&id=19c63d5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c63d5d",
  null
  
)

export default component.exports